import React, { useEffect, useState } from 'react';
import './AreaDetail.scss';
import affordability from '../../assets/areaDetail/affordability.svg';
import population from '../../assets/areaDetail/population.svg';
import medianPrice from '../../assets/areaDetail/medianPrice.svg';
import permit from '../../assets/areaDetail/permit.svg';
import i from '../../assets/areaDetail/i.svg';
import PopUpInfo from './PopUpInfo';
import Arrows from './Arrows';
import nationalAverage from '../../nationalAverage';

const ntlSup = nationalAverage.supply;
const ntlMedPrice = nationalAverage.medianPrice;
const ntlYoy = nationalAverage.yoyChange;
const ntlAffor = nationalAverage.affordability;
const ntlPop = nationalAverage.popChange;

function AreaDetail({
  currentClickedArea,
  setSavedData,
  savedData,
  checked,
  setChecked,
  checkbox,
  setShowAreaDetail,
  setSavedDataArray,
  setCurrentClickedArea,
  areaDetailRef
}) {
  const [popUpOpen, setPopUpOpen] = useState(false);
  const [score, setScore] = useState({});

  useEffect(() => {
    const temp = {};
    const currentSupply = Number(currentClickedArea.job);
    const currentYoy = Number(currentClickedArea.yoyChange);
    const currentHai = Number(currentClickedArea.hai);
    const currentGrowth = Number(currentClickedArea.growth);
    if (currentClickedArea) {
      if (currentSupply > ntlSup) {
        temp.supply = 'less';
      } else if (currentSupply < ntlSup) {
        temp.supply = 'more';
      } else if (currentSupply === ntlSup) {
        temp.supply = 'equal';
      } else {
        temp.supply = 'null';
      }

      if (currentYoy < ntlYoy) {
        temp.yoyChange = 'below';
      } else if (currentYoy > ntlYoy) {
        temp.yoyChange = 'above';
      } else if (currentYoy === ntlYoy) {
        temp.yoyChange = 'equal';
      }

      if (currentHai < ntlAffor) {
        temp.hai = 'below';
      } else if (currentHai > ntlAffor) {
        temp.hai = 'above';
      } else if (currentHai === ntlAffor) {
        temp.hai = 'equal';
      } else {
        temp.hai = 'null';
      }

      if (currentGrowth < ntlPop) {
        temp.forecast = 'below';
      } else if (currentGrowth > ntlPop) {
        temp.forecast = 'above';
      } else if (currentGrowth === ntlPop) {
        temp.forecast = 'equal';
      }
    }

    setScore(temp);
  }, [currentClickedArea]);

  const handleCheckbox = () => {
    let data = savedData;
    let check = Object.assign(checked);
    if (currentClickedArea) {
      if (!check.hasOwnProperty(currentClickedArea.fips)) {
        check[currentClickedArea.fips] = true;
        setChecked(check);

        if (!savedData.hasOwnProperty(currentClickedArea.fips)) {
          data[currentClickedArea.fips] = true;
        }
      } else {
        delete check[currentClickedArea.fips];
        setChecked(check);
        if (savedData.hasOwnProperty(currentClickedArea.fips)) {
          delete data[currentClickedArea.fips];
        }
      }
      setSavedData(data);
    }
    setSavedDataArray(Object.keys(data));
  };

  return (
    <section className="areaDetail" ref={areaDetailRef}>
      <div className="areaDetail__head">
        <div
          className="areaDetail__x"
          onClick={() => {
            setShowAreaDetail(false);
            setCurrentClickedArea(null);
          }}
        >
          X
        </div>

        <div className="areaDetail__head__title">
          <p
            className={
              currentClickedArea && currentClickedArea.name.length < 25
                ? 'areaDetail__head__title__name'
                : 'areaDetail__head__title__name areaDetail__head__title__name--small'
            }
          >
            {currentClickedArea ? currentClickedArea.name : null}
          </p>
          <p
            className={
              currentClickedArea && currentClickedArea.state.length < 25
                ? 'areaDetail__head__title__state'
                : 'areaDetail__head__title__state areaDetail__head__title__state--small'
            }
          >
            {currentClickedArea ? currentClickedArea.state.toUpperCase() : null}
          </p>
        </div>
        <div className="areaDetail__head__checkbox">
          {currentClickedArea.fips ? (
            <input
              className="areaDetail__head__checkbox__checkbox"
              type="checkbox"
              onChange={handleCheckbox}
              checked={checked[currentClickedArea.fips] ? true : false}
              ref={checkbox}
            />
          ) : null}

          <p className="areaDetail__head__checkbox__text">COMPARE</p>
        </div>
      </div>
      <div className="areaDetail__content">
        <PopUpInfo popUpOpen={popUpOpen} setPopUpOpen={setPopUpOpen} />
        <div className="areaDetail__content__detail">
          <img src={permit} alt="icon" className="icon" />
          <div className="areaDetail__content__detail__texts">
            <p className="areaDetail__content__detail__main">
              {currentClickedArea && currentClickedArea.job !== 'N/A'
                ? `1 housing permit for every ${
                    currentClickedArea ? currentClickedArea.job : null
                  } new jobs`
                : null}
              {currentClickedArea && currentClickedArea.job === 'N/A' ? `Data not available` : null}
            </p>
            <p className="areaDetail__content__detail__sub">
              National Average: <span className="grey">1</span> single-family permit issued for
              every <span className="grey">{ntlSup}</span> new jobs.
            </p>
          </div>
          <Arrows score={score.supply ? score.supply : null} />
        </div>
        <div className="areaDetail__content__detail">
          <img src={medianPrice} alt="icon" className="icon" />
          <div className="areaDetail__content__detail__texts">
            <p className="areaDetail__content__detail__main">
              ${currentClickedArea ? currentClickedArea.medianPrice : null} median home price
              <br />
              {currentClickedArea ? (currentClickedArea.yoyChange[0] !== '-' ? '+' : '') : null}
              {currentClickedArea ? currentClickedArea.yoyChange : null}% year-over-year change
            </p>
            <p className="areaDetail__content__detail__sub areaDetail__content__detail__sub--even">
              National Median: <span className="grey">${ntlMedPrice}</span> <br />
              <span className="grey">+{ntlYoy}%</span> year-over-year
            </p>
          </div>
          <Arrows score={score.yoyChange ? score.yoyChange : null} />
        </div>
        <div className="areaDetail__content__detail">
          <img src={affordability} alt="icon" className="icon" />
          <div className="areaDetail__content__detail__texts">
            <p className="areaDetail__content__detail__main nobreak">
              {currentClickedArea && currentClickedArea.hai !== 'N/A'
                ? `${currentClickedArea.hai} on the
              Affordability Score`
                : null}
              {currentClickedArea && currentClickedArea.hai === 'N/A' ? `Data not available` : null}
              <span className="popup-icon">
                <img
                  src={i}
                  className="i"
                  alt="info"
                  onClick={() => {
                    setPopUpOpen(!popUpOpen);
                  }}
                />
              </span>
            </p>
            <p className="areaDetail__content__detail__sub">
              National Average: <span className="grey">{ntlAffor}</span>
              <br /> Historical Average: <span className="grey">138</span>
            </p>
          </div>
          <Arrows score={score.hai ? score.hai : null} />
        </div>
        <div className="areaDetail__content__detail">
          <img src={population} alt="icon" className="icon" />
          <div className="areaDetail__content__detail__texts">
            <p className="areaDetail__content__detail__main">
              {currentClickedArea ? (currentClickedArea.growth[0] !== '-' ? '+' : '') : null}
              {currentClickedArea ? currentClickedArea.growth : null}% 10-yr population change
            </p>
            <p className="areaDetail__content__detail__sub areaDetail__content__detail__sub--even">
              10-yr national change: <span className="grey">+{ntlPop}%</span>
            </p>
          </div>
          <Arrows score={score.forecast ? score.forecast : null} />
        </div>
      </div>
    </section>
  );
}

export default AreaDetail;
